<template>
    <div>
        <PrescriptionFilter
            v-if="isFiltersReady"
            class="ml-3"
            :filter-model.sync="filter"
            :contracts="contractOptions"
            :periods="periodOptions"
            :objects="objectOptions"
            :ksk="kskOptions"
            @resetFilter="resetFilter"
            @applyFilter="applyFilter"
        />
        <v-btn color="success" class="ml-3 mt-4" :disabled="!PLT.length || isExporting" :loading="isExporting" @click="exportToExcel">
            <v-icon left>mdi-file-excel</v-icon>
            Выгрузить в Excel
        </v-btn>
        <v-btn class="mt-5" color="primary" @click="addPresc" v-show="userPermissions.some(x => x === 'prescription_ozp_form')">{{ $t('Добавить') }}</v-btn>
        <v-data-table
            class="mt-5"
            :headers="headers"
            :items="PLT"
            :options.sync="prescriptionOZPPagination"
            :server-items-length="PrescriptionOZPListLength"
            :loading="PrescriptionOZPLoading"
            :footer-props="{ 'items-per-page-options': $vuetify.breakpoint.xsOnly ? [1] : [10, 15, 20, 25] }"
            item-key="record_id"
            checkbox-color="#6B7BB2"
            v-model="selectedSync"
            @click:row="(item, event) => goToDetails(item)"
        >
            <template v-slot:item.object_or_ksk="{ item }">
                <span>{{ item.object_name || item.ksk_name || '' }}</span>
            </template>
            <template v-slot:item.data-table-select="{ item, isSelected, select }">
                <td style="vertical-align: top">
                    <v-simple-checkbox :input-value="isSelected" @click.stop="select(!isSelected)" color="gray" style="margin:0; padding:0" />
                </td>
            </template>

            <template v-slot:item.is_formed="{ item }">
                <span> {{ item.is_formed ? $t('да') : $t('нет') }} </span>
            </template>
            <template v-slot:item.note="{ item }">
                <div class="d-flex align-center">
                    <span> {{ item.note }} </span>
                </div>
            </template>
            <template v-slot:item.record_id="{ item }">
                <div class="d-flex align-center justify-space-around">
                    <v-btn
                        v-show="item.status_code_name !== 'canceled' && item.status_code_name !== 'completed'"
                        icon
                        @click="openDeleteDialog(item)"
                        :title="$t('Аннулирование предписания')"
                        v-if="userPermissions.some(x => x === 'prescription_ozp_form')"
                        ><v-icon>mdi-delete-forever</v-icon></v-btn
                    >
                    <v-btn icon @click="openEdit(item.record_id)" :title="$t('Редактирование предписания')"><v-icon>edit</v-icon></v-btn>
                </div>
            </template>
            <template v-slot:item.issue_date="{ item }">
                <span> {{ item.issue_date | formatDate }} </span>
            </template>
            <template v-slot:item.status_name="{ item }">
                <span>{{ item.status_name }}</span>
                <v-btn
                    color="primary"
                    v-show="item.status_code_name === 'formed' || item.status_code_name === 'issued'"
                    @click="StatusChange(item)"
                    v-if="userPermissions.some(x => x === 'prescription_ozp_form')"
                    >{{ $t('Изменить') }}</v-btn
                >
            </template>
        </v-data-table>
        <v-dialog v-model="deleteDialog" eager max-width="350px">
            <LabeledCard :label="$t('Подтвердите аннулирование')">
                <div class="d-flex align-center justify-center mt-5 mb-5">
                    <span>
                        {{ $t('Аннулировать предписание?') }}
                    </span>
                </div>
                <div class="d-flex align-center justify-space-around mt-5 mb-5">
                    <v-btn outlined color="primary" @click="deleteDialog = false">{{ $t('нет') }}</v-btn>
                    <v-btn color="primary" @click="deletePresc">{{ $t('да') }}</v-btn>
                </div>
            </LabeledCard>
        </v-dialog>
        <v-dialog v-model="changeStatusDialog" eager max-width="300px">
            <LabeledCard :label="$t('Изменение статуса')">
                <div class="d-flex align-center justify-center mt-5 mb-5">
                    <span>
                        {{ $t('Изменить статус на ') + nextStatusName + '?' }}
                    </span>
                </div>
                <div class="d-flex align-center justify-space-around mt-5 mb-5">
                    <v-btn outlined color="primary" @click="changeStatusDialog = false">{{ $t('нет') }}</v-btn>
                    <v-btn color="primary" @click="changeStatus()">{{ $t('да') }}</v-btn>
                </div>
            </LabeledCard>
        </v-dialog>
    </div>
</template>

<script>
import translate from '@/utils/translate.util';
import { mapState, mapActions } from 'vuex';
import LabeledCard from '@/components/ui/LabeledCard.vue';
import PrescriptionFilter from '@/components/PrescriptionFilter.vue';
import * as XLSX from 'xlsx';

const PRESCRIPTION_LIST_STATE_KEY = 'prescriptionOZPListState';

export default {
    name: 'PrescriptionOZP',
    components: { LabeledCard, PrescriptionFilter },
    data: () => ({
        isFiltersReady: false,
        engineer_rid: null,
        boss: 0,
        contract_number: null,
        contract_rid: null,
        period_rid: null,
        isContract: true,
        ksk_rid: null,
        user_id: null,
        deleteDialog: false,
        selectedPresc: null,
        selected: [],
        changeStatusDialog: false,
        isTableReady: false,
        isExporting: false,
        filter: {
            contract_rid: null,
            period_rid: null,
            prescription_number: null,
            sum_debt: null,
            person_name: null,
            isServiceConnected: null,
            account_number: null,
            selectedDistrictRid: null,
            notice_status_type_rid: null,
            selectedAddress: {}
        }
    }),
    watch: {
        EngineerContractsList: {
            handler(v) {},
            immediate: true
        },
        EngineerObjectsList: {
            handler(v) {},
            immediate: true
        },
        PeriodsList: {
            handler(v) {},
            immediate: true
        },
        KSKList: {
            handler(v) {},
            immediate: true
        }
    },
    computed: {
        ...mapState('prescription_ozp', [
            'EngineerContractsList',
            'EngineerObjectsList',
            'PeriodsList',
            'KSKList',
            'PrescriptionOZPList',
            'PrescriptionOZPListLength',
            'PrescriptionOZPPagination',
            'PrescriptionOZPLoading',
            'prescriptionOZPStatusTypes'
        ]),
        ...mapState('users', ['userInfo']),
        ...mapState('permissions', ['userPermissions']),
        objectOptions() {
            const list = Array.isArray(this.EngineerObjectsList) ? this.EngineerObjectsList : [];
            return list.map(o => ({ object_name: String(o.object_name___ru ?? o.object_name ?? '') }));
        },
        contractOptions() {
            const list = Array.isArray(this.EngineerContractsList) ? this.EngineerContractsList : [];
            return list.map(c => ({ contract_rid: Number(c.contract_rid), contract_number: String(c.contract_number) }));
        },
        periodOptions() {
            const list = Array.isArray(this.PeriodsList) ? this.PeriodsList : [];
            return list.map(c => ({ rid: Number(c.rid), name: String(c.name) }));
        },
        kskOptions() {
            const src = this.KSKList;
            const list = Array.isArray(src?.ksk) ? src.ksk : Array.isArray(src) ? src : [];
            return list.map(k => ({
                rid: Number(k.record_id ?? k.rid ?? 0),
                name: String(k.ksk_name___ru ?? k.name ?? '')
            }));
        },

        headers: function() {
            return [
                {
                    text: this.$t('№ п/п'),
                    sortable: false,
                    value: 'row_num'
                },
                {
                    text: this.$t('№ Договора'),
                    sortable: false,
                    value: 'contract_number'
                },
                {
                    text: this.$t('Наименование объекта/КСК'),
                    sortable: false,
                    value: 'object_or_ksk'
                },
                {
                    text: this.$t('Адрес'),
                    sortable: false,
                    value: 'address_full_name'
                },
                {
                    text: this.$t('№ предписания'),
                    sortable: false,
                    value: 'prescription_number'
                },
                {
                    text: this.$t('Дата выдачи'),
                    sortable: false,
                    value: 'issue_date'
                },
                {
                    text: this.$t('Период'),
                    sortable: false,
                    value: 'formed_period'
                },
                {
                    text: this.$t('Статус предписания'),
                    sortable: false,
                    value: 'status_name'
                }
            ];
        },

        PLT() {
            return translate(this.PrescriptionOZPList, 'full', this.$i18n.locale);
        },
        prescriptionOZPPagination: {
            get() {
                return this.PrescriptionOZPPagination;
            },

            async set(val) {
                this.$store.commit('prescription_ozp/setPrescriptionOZPPagination', val);

                if (!this.isTableReady) {
                    return;
                }

                this.saveListState();

                await this.loadTable();
            }
        },
        PSTT() {
            return translate(this.prescriptionOZPStatusTypes, 'full', this.$i18n.locale);
        },
        nextStatusName() {
            if (!this.selectedPresc) return;
            if (this.selectedPresc.status_code_name === 'formed') return this.PSTT.find(x => x.status_code_name === 'issued').status_name;
            if (this.selectedPresc.status_code_name === 'issued') return this.PSTT.find(x => x.status_code_name === 'completed').status_name;
            else return '';
        },
        selectedSync: {
            get() {
                return this.selected;
            },
            set(val) {
                this.selected = val;
            }
        }
    },
    methods: {
        ...mapActions('prescription_ozp', [
            'getPrescriptionsOZP',
            'getPrescriptionsOZPForExport',
            'getEventTypes',
            'postPrescriptionsOZP',
            'getEngineerKSKHousesList',
            'getEngineerObjectContractsList',
            'getEngineerContractsList',
            'getEngineerObjectsList',
            'getPeriodsList',
            'getKSKList',
            'GetPrescriptionOZPStatusTypes',
            'prescriptionOZPStatusChange'
        ]),
        ...mapActions('users', ['getUserInfo']),
        applyFilter() {
            this.PrescriptionOZPPagination.page = 1;

            this.saveListState();

            this.loadTable();
        },
        resetFilter() {
            this.itemStart = 0;

            this.filter = {
                contract_rid: null,
                period_rid: null,
                prescription_number: null,
                ksk_rid: null,
                object_name: null,
                name: '',
                year: null,
                statuses: [],
                sum_debt: null,
                person_name: null,
                isServiceConnected: null,
                account_number: null,
                selectedDistrictRid: null,
                notice_status_type_rid: null,
                selectedAddress: {}
            };

            this.$store.commit('prescription_ozp/setPrescriptionOZPPagination', {
                ...this.PrescriptionOZPPagination,
                page: 1
            });

            sessionStorage.removeItem(PRESCRIPTION_LIST_STATE_KEY);

            this.loadTable();
        },
        saveListState() {
            const state = {
                filter: {
                    ...this.filter,
                    statuses: Array.isArray(this.filter.statuses) ? [...this.filter.statuses] : []
                },
                pagination: {
                    ...this.PrescriptionOZPPagination
                }
            };

            sessionStorage.setItem(PRESCRIPTION_LIST_STATE_KEY, JSON.stringify(state));
        },

        restoreListState() {
            try {
                const raw = sessionStorage.getItem(PRESCRIPTION_LIST_STATE_KEY);

                if (!raw) {
                    return false;
                }

                const state = JSON.parse(raw);

                if (state.filter) {
                    this.filter = {
                        ...this.filter,
                        ...state.filter,
                        statuses: Array.isArray(state.filter.statuses) ? state.filter.statuses : []
                    };
                }

                if (state.pagination) {
                    this.$store.commit('prescription_ozp/setPrescriptionOZPPagination', {
                        ...this.PrescriptionOZPPagination,
                        ...state.pagination
                    });
                }

                return true;
            } catch (e) {
                console.error('Ошибка восстановления состояния списка предписаний', e);
                sessionStorage.removeItem(PRESCRIPTION_LIST_STATE_KEY);
                return false;
            }
        },
        StatusChange(item) {
            this.changeStatusDialog = true;
            this.selectedPresc = item;
        },
        async changeStatus() {
            this.changeStatusDialog = false;
            let statusRid = null;
            if (this.selectedPresc.status_code_name === 'formed') statusRid = this.PSTT.find(x => x.status_code_name === 'issued').status_rid;
            if (this.selectedPresc.status_code_name === 'issued') statusRid = this.PSTT.find(x => x.status_code_name === 'completed').status_rid;
            await this.prescriptionOZPStatusChange({ iPrescription_rid: this.selectedPresc.record_id, iStatus_rid: statusRid });
            this.loadTable();
        },
        openDeleteDialog(item) {
            this.deleteDialog = true;
            this.selectedPresc = item;
        },
        goToDetails(item) {
            this.saveListState();

            this.$router.push({
                name: 'PrescriptionOZPDetail',
                params: {
                    id: item.record_id
                }
            });
        },
        async deletePresc() {
            let statusRid = null;
            statusRid = this.PSTT.find(x => x.status_code_name === 'canceled').status_rid;
            await this.prescriptionOZPStatusChange({ iPrescription_rid: this.selectedPresc.record_id, iStatus_rid: statusRid });
            await this.loadTable();
            this.deleteDialog = false;
        },
        async loadTable() {
            await this.getPrescriptionsOZP({
                engineer_rid: this.engineer_rid ?? null,
                boss: this.boss ?? null,
                contract_rid: this.filter.contract_rid ?? null,
                period_rid: this.filter.period_rid ?? null,
                prescription_number: this.filter.prescription_number ?? null,
                ksk_rid: this.filter.ksk_rid ?? null,
                user_id: this.user_id ?? null,
                object_name: this.filter.object_name ?? null,
                status_code_name: this.filter.statuses && this.filter.statuses.length ? this.filter.statuses : null,
                itemsPerPage: this.PrescriptionOZPPagination.itemsPerPage,
                currentItem: this.PrescriptionOZPPagination.itemsPerPage * (this.PrescriptionOZPPagination.page - 1)
            });
        },
        async addPresc() {
            this.$router.push('/addprescription_ozp');
        },
        async openEdit(record_id) {
            this.saveListState();

            this.$router.push('/editprescription_ozp/' + String(record_id));
        },
        async exportToExcel() {
            if (this.isExporting) return;

            this.isExporting = true;

            try {
                const pageSize = 500;
                const total = Number(this.PrescriptionOZPListLength);

                if (!total) return;

                const params = {
                    engineer_rid: this.engineer_rid ?? null,
                    boss: this.boss ?? null,
                    contract_rid: this.filter.contract_rid ?? null,
                    period_rid: this.filter.period_rid ?? null,
                    prescription_number: this.filter.prescription_number ?? null,
                    ksk_rid: this.filter.ksk_rid ?? null,
                    user_id: this.user_id ?? null,
                    object_name: this.filter.object_name ?? null,
                    status_code_name: this.filter.statuses?.length ? this.filter.statuses : null
                };

                const allItems = [];

                for (let offset = 0; offset < total; offset += pageSize) {
                    const items = await this.getPrescriptionsOZPForExport({
                        ...params,
                        itemsPerPage: pageSize,
                        currentItem: offset
                    });

                    if (!Array.isArray(items)) {
                        throw new Error('Некорректный ответ API');
                    }

                    allItems.push(...items);

                    if (items.length < pageSize) {
                        break;
                    }
                }

                if (allItems.length !== total) {
                    throw new Error(`Загружено ${allItems.length} из ${total} записей`);
                }

                const translatedList = translate(allItems, 'full', this.$i18n.locale);

                const rows = translatedList.map(item => ({
                    '№ Договора': item.contract_number || '',
                    'Наименование объекта/КСК': item.object_name || item.ksk_name || '',
                    Адрес: item.address_full_name || '',
                    '№ предписания': item.prescription_number || '',
                    'Дата выдачи': item.issue_date
                        ? item.issue_date
                              .split('-')
                              .reverse()
                              .join('.')
                        : '',
                    Период: item.formed_period || '',
                    'Статус предписания': item.status_name || ''
                }));

                const worksheet = XLSX.utils.json_to_sheet(rows);

                worksheet['!cols'] = [{ wch: 15 }, { wch: 35 }, { wch: 45 }, { wch: 15 }, { wch: 15 }, { wch: 15 }, { wch: 20 }];

                const workbook = XLSX.utils.book_new();

                XLSX.utils.book_append_sheet(workbook, worksheet, 'Предписания');

                XLSX.writeFile(workbook, 'Предписания.xlsx');
            } catch (error) {
                console.error('Ошибка выгрузки Excel:', error);
            } finally {
                this.isExporting = false;
            }
        }
    },
    async created() {
        await this.getUserInfo();

        if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_ksk_rid) {
            this.ksk_rid = this.userInfo.user_data.isas_ksk_rid;
            this.isContract = false;
        } else if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_contract_rid) {
            this.contract_rid = this.userInfo.user_data.isas_contract_rid;
            this.isContract = true;
        }
        if (this.userInfo && this.userInfo.user_data && this.userInfo.user_data.isas_engineer_rid) {
            this.engineer_rid = this.userInfo.user_data.isas_engineer_rid;
        }
        this.user_id = this.userInfo.record_id;

        const translated = translate(this.userInfo || {}, 'full', this.$i18n.locale);

        if (
            translated?.role_name?.role_name?.includes?.('Инспектор') ||
            translated?.role_name?.role_name?.includes?.('Администратор ОЗП') ||
            translated?.role_name?.role_name?.includes?.('Администратор. AHS') ||
            translated?.role_name?.role_name?.includes?.('Әкімші. AHS')
        ) {
            this.boss = 1;
            this.engineer_rid = null;
        }

        this.user_id = this.userInfo?.record_id ?? null;

        //this.engineer_rid = 2;
        this.$store.commit('prescription_ozp/setiengineer_rid', this.engineer_rid);

        const iengineer_rid = this.boss === 1 ? 0 : Number(this.engineer_rid) || null;

        await Promise.all([
            this.getEngineerContractsList({ iengineer_rid: Number(this.engineer_rid) || 0 }),
            this.getEngineerObjectsList({ iengineer_rid: Number(this.engineer_rid) || 0 }),
            this.getPeriodsList(),
            this.getKSKList()
        ]);

        this.restoreListState();

        this.isFiltersReady = true;
        this.isTableReady = true;

        await this.loadTable();
    }
};
</script>
<style scoped>
.v-data-table >>> tbody tr {
    cursor: pointer;
}
</style>
